import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IInvoice, IOrder } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/my/invoices';

interface IGetRequest {
  isApply: boolean;
}

interface IGetResult {
  orders: IOrder[];
  lastInvoice: IInvoice;
  items: IInvoice[];
}

interface ISubmitRequest {
  orderNos: string[];
  amount: number;
  isVatSpecial: boolean;
  isElectronic: boolean;
  taxTitle: string;
  taxNo: string;
  taxAddress: string;
  taxTel: string;
  taxBankName: string;
  taxBankNo: string;
  deliveryName: string;
  deliveryTel: string;
  deliveryAddress: string;
  email: string;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: IBoolResult) => void, failure: () => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
        failure();
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
